/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * ETag for optimistic concurrency control.
 */
export type SubmissionEtag = string | null;
